import {
  GET_LIST,
  SET_UPLOAD_PROGRESS,
  UPDATE_PHOTO_SOURCE,
  ADD_PHOTO,
  RENAME_PHOTO,
  DELETE_PHOTO,
  SET_LOADER
} from "./photosActionTypes";

const photosReducer = (state, action) => {
  switch (action.type) {
    case GET_LIST:
      return { ...state, list: action.payload };
    case SET_UPLOAD_PROGRESS:
      return _setUploadProgress(state, action);
    case UPDATE_PHOTO_SOURCE:
      return _updatePhotoSource(state, action);
    case ADD_PHOTO:
      return _addPhoto(state, action);
    case RENAME_PHOTO:
      return _renamePhoto(state, action);
    case DELETE_PHOTO:
      return _deletePhoto(state, action);
    case SET_LOADER:
      return _setLoader(state, action);
    default:
      return state;
  }
};

const _setLoader = (state, action) => {
  const newPhotoList = [...state.list];
  const fileName = action.payload.fileName;
  const loaderType = action.payload.loader;

  for (let i = 0; i < newPhotoList.length; i++) {
    if (newPhotoList[i].fileName === fileName) {
      newPhotoList[i].loader = {...newPhotoList[i].loader, [loaderType]: true}
    }
  }
  return { ...state, list: newPhotoList };
}

const _deletePhoto = (state, action) => {
  const newPhotoList = [...state.list];
  const fileName = action.payload;
  let filteredList = newPhotoList.filter(photo => photo.fileName !== fileName);
  return { ...state, list: filteredList };
}

const _setUploadProgress = (state, action) => {
  const newPhotoList = [...state.list];
  const photoId = action.payload.photoId;
  const progress = action.payload.progress;

  for (let i = 0; i < newPhotoList.length; i++) {
    if (newPhotoList[i].id === photoId &&
      newPhotoList[i].progress < progress) {
      newPhotoList[i].progress = progress;
    }
  }
  return { ...state, list: newPhotoList };
}

const _updatePhotoSource = (state, action) => {
  const newPhotoList = [...state.list];
  const photoId = action.payload.photoId;
  const filePath = action.payload.filePath;
  for (let i = 0; i < newPhotoList.length; i++) {
    if (newPhotoList[i].id === photoId) {
      newPhotoList[i].data = `/api/photo?path=${filePath}`;
      newPhotoList[i].uploaded = true;
      newPhotoList[i].fileName = filePath.replace(/^.*[\\/]/, '');
    }
  }
  return { ...state, list: newPhotoList };
};

const _addPhoto = (state, action) => {
  const newPhotoList = [...state.list];
  newPhotoList.push(action.payload);
  return { ...state, list: newPhotoList };
}

const _renamePhoto = (state, action) => {
  const newPhotoList = [...state.list];
  for (let i = 0; i < newPhotoList.length; i++) {
    if (newPhotoList[i].id === action.payload.photoId) {
      newPhotoList[i].data = newPhotoList[i].data.replace(newPhotoList[i].fileName, action.payload.newName);
      newPhotoList[i].fileName = action.payload.newName;
      newPhotoList[i].loader = {...newPhotoList[i].loader, rename: false, addToReport: false}
    }
  }
  return { ...state, list: newPhotoList };
}

export default photosReducer;
